export default __webpack_public_path__ + "static/2.5.1/media/unwantedExaminationResults.9d8ee8e8.svg";